import { render, staticRenderFns } from "./HistoricalQuotation.vue?vue&type=template&id=38c1b5ef"
import script from "./HistoricalQuotation.vue?vue&type=script&lang=js"
export * from "./HistoricalQuotation.vue?vue&type=script&lang=js"
import style0 from "./HistoricalQuotation.vue?vue&type=style&index=0&id=38c1b5ef&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports